var map = {
	"./M98/banner_en.png": "ca6d",
	"./M98/banner_id.png": "aae6",
	"./M98/banner_th.png": "96d3",
	"./M98/banner_usdt.png": "8606",
	"./M98/banner_yn.png": "f75d",
	"./M98/banner_zh.png": "f4f2",
	"./a1.png": "c270",
	"./a2.png": "58a7",
	"./b1.png": "c52e",
	"./b2.png": "8c96",
	"./btn_close.png": "2bf6",
	"./c1.png": "8109",
	"./c2.png": "f8e7",
	"./cn.png": "3cfc",
	"./find.png": "348e",
	"./flag_Vietnamese.png": "de42",
	"./id.png": "45d4",
	"./itemBg.png": "2844",
	"./itemFooter.png": "cb06",
	"./itemHeader.png": "9016",
	"./line.png": "3afa",
	"./logo.png": "255e",
	"./logo1.png": "dd00",
	"./new_a1.png": "e235",
	"./new_a2.png": "4254",
	"./new_c1.png": "188b",
	"./new_c2.png": "7a9c",
	"./text.png": "67f7",
	"./th.png": "1282"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2655";